import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Regex from "./../concerns/regex";

const TextField = ({
  model,
  label,
  field,
  required,
  kind,
  inputIsValid,
  index,
  type,
  errorMessage,
}) => {
  const [text, setText] = useState("");
  const [regex, setRegex] = useState("");
  const [validClass, setValidClass] = useState("");
  const [displayErrorMessage, setDisplayErrorMessage] = useState(false);

  const id = `${model}_${field}`;
  const name = `${model}[${field}]`;

  useEffect(() => {
    switch (kind) {
      case "email":
        setRegex(Regex["email"]);
        break;
      case "phone":
        setRegex(Regex["phone"]);
        break;
      case "name":
        setRegex(Regex["name"]);
        break;
      case "address":
        setRegex(Regex["address"]);
        break;
      case "zipCode":
        setRegex(Regex["zipCode"]);
        break;
      case "number":
        setRegex(Regex["number"]);
        break;
    }
  }, []);

  const regexValid = (regex, input) => {
    if (regex) {
      return regex.test(input);
    } else {
      return true;
    }
  };

  const validation = (text) => {
    setValidClass("border-green-500");
    if (required) {
      if (text != "" && regexValid(regex, text)) {
        setValidClass("border-green-500");
        if (inputIsValid) {
          inputIsValid(true, index);
        }
        setDisplayErrorMessage(false);
      } else {
        setValidClass("border-red-500");
        if (inputIsValid) {
          inputIsValid(false, index);
        }
        setDisplayErrorMessage(true);
      }
    }
  };

  return (
    <div className="mt-3">
      <label className="block uppercase tracking-wide text-blueGray-800 text-base font-bold mb-2">
        {label}
      </label>
      <input
        type={type}
        id={id}
        name={name}
        required={required}
        value={text}
        className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${validClass}`}
        onChange={(event) => {
          setText(event.target.value);
          validation(event.target.value);
        }}
      />
      {displayErrorMessage && (
        <div className="text-red-500 mt-2">{errorMessage}</div>
      )}
    </div>
  );
};

TextField.propTypes = {
  label: PropTypes.string,
  model: PropTypes.string,
  field: PropTypes.string,
  kind: PropTypes.string,
  required: PropTypes.bool,
};

export default TextField;
